import { defaultServiceLanguage, ServiceLanguage } from "@albertine/i18n";
import classNames from "classnames";
import { Plus } from "lucide-react";
import type React from "react";
import { MenuButton, type MenuButtonOptions } from "./Button/MenuButton";
import Label from "./Label";
import { Tabs } from "./Tabs";

type TranslationTabsProps = {
    keepAllTabsRendered?: boolean;
    translationOptions: MenuButtonOptions;
    tabs: {
        key: ServiceLanguage;
        text: string;
        children: React.ReactNode;
    }[];
    onTabClick?: (key: ServiceLanguage) => void;
};

function TranslationTabs(props: TranslationTabsProps) {
    const { keepAllTabsRendered, tabs, translationOptions, onTabClick } = props;

    const hasTranslationOptions = translationOptions.length !== 0;
    const showAddTranslations =
        hasTranslationOptions && ServiceLanguage.options.length !== tabs.length;

    return (
        <Tabs
            tabs={tabs}
            defaultTab={defaultServiceLanguage}
            keepAllTabsRendered={keepAllTabsRendered}
            onTabClick={onTabClick}
            tabBarClassName={classNames({
                "border-zinc-100! bg-zinc-100!": hasTranslationOptions,
            })}
            trailing={
                showAddTranslations ? (
                    <MenuButton
                        options={translationOptions}
                        placement="left"
                        button={
                            <span className="flex items-center gap-1">
                                <Plus className="size-4 text-emerald-600" />
                                <Label.Medium.SemiBold.P50>
                                    Add translations
                                </Label.Medium.SemiBold.P50>
                            </span>
                        }
                    />
                ) : undefined
            }
        />
    );
}

export default TranslationTabs;
